import React from "react";
import { ReactComponent as ServiceFluShotIcon } from "../images/service-flu-shot.svg";
import { ReactComponent as ServiceConsultationIcon } from "../images/service-consultation.svg";
import { ReactComponent as Covid19TestIcon } from "../images/service-covid-19-test.svg";
import { ReactComponent as ServiceCovid19Vax } from "../images/service-flu-shot.svg";
import {
  SERVICE_COVID_19_TEST,
  SERVICE_COVID_19_TEST_ANTIGEN,
  SERVICE_COVID_19_TEST_MEXICO,
  SERVICE_COVID_19_TEST_MEXICO_ANTIGEN,
  SERVICE_CONSULT,
  SERVICE_FLU_SHOT,
  SERVICE_COVID_19_VAX,
  SERVICE_COVID_19_VACCINE_MODERNA_1,
  SERVICE_COVID_19_VACCINE_MODERNA_2,
  SERVICE_COVID_19_VACCINE_PFIZER_1,
  SERVICE_COVID_19_VACCINE_PFIZER_2,
  SERVICE_COVID_19_VACCINE_JNJ,
  SERVICE_COVID_19_VACCINE_NOVAVAX_1,
  SERVICE_COVID_19_VACCINE_NOVAVAX_2,
  SERVICE_COVID_19_VACCINE_AZ_1,
  SERVICE_COVID_19_VACCINE_AZ_2,
  SERVICE_COVID_19_TEST_KS,
  SERVICE_COVID_19_TEST_KS_ANTIGEN,
  SERVICE_COVID_19_TEST_NV,
  SERVICE_COVID_19_TEST_NV_ANTIGEN,
  SERVICE_COVID_19_TEST_MX_RESORT
} from "./availableServices";

const API_SERVICE_MAP = {
  [SERVICE_COVID_19_TEST]: {
    label: "COVID-19 Test (PCR)",
    icon: <Covid19TestIcon />
  },
  [SERVICE_COVID_19_TEST_ANTIGEN]: {
    label: "COVID-19 Test (Antigen)",
    icon: <Covid19TestIcon />
  },
  [SERVICE_COVID_19_TEST_MEXICO]: {
    label: "COVID-19 Test (PCR)",
    icon: <Covid19TestIcon />
  },
  [SERVICE_COVID_19_TEST_MEXICO_ANTIGEN]: {
    label: "COVID-19 Test (Antigen)",
    icon: <Covid19TestIcon />
  },
  [SERVICE_COVID_19_TEST_KS]: {
    label: "COVID-19 Test (PCR)",
    icon: <Covid19TestIcon />
  },
  [SERVICE_COVID_19_TEST_KS_ANTIGEN]: {
    label: "COVID-19 Test (Antigen)",
    icon: <Covid19TestIcon />
  },
  [SERVICE_COVID_19_TEST_NV]: {
    label: "COVID-19 Test (PCR)",
    icon: <Covid19TestIcon />
  },
  [SERVICE_COVID_19_TEST_NV_ANTIGEN]: {
    label: "COVID-19 Test (Antigen)",
    icon: <Covid19TestIcon />
  },
  [SERVICE_COVID_19_TEST_MX_RESORT]: {
    label: "COVID-19 Test (PCR)",
    icon: <Covid19TestIcon />
  },
  [SERVICE_CONSULT]: {
    label: "Consult",
    icon: <ServiceConsultationIcon />
  },
  [SERVICE_FLU_SHOT]: {
    label: "Flu Shot",
    icon: <ServiceFluShotIcon />
  },
  [SERVICE_COVID_19_VAX]: {
    label: "Covid-19 Vaccination",
    icon: <ServiceCovid19Vax />
  },
  [SERVICE_COVID_19_VACCINE_MODERNA_1]: {
    label: "Covid-19 Vaccination - Dose 1 (Moderna)",
    icon: <ServiceCovid19Vax />
  },
  [SERVICE_COVID_19_VACCINE_MODERNA_2]: {
    label: "Covid-19 Vaccination - Dose 2 (Moderna)",
    icon: <ServiceCovid19Vax />
  },
  [SERVICE_COVID_19_VACCINE_PFIZER_1]: {
    label: "Covid-19 Vaccination - Dose 1 (Pfizer)",
    icon: <ServiceCovid19Vax />
  },
  [SERVICE_COVID_19_VACCINE_PFIZER_2]: {
    label: "Covid-19 Vaccination - Dose 2 (Pfizer)",
    icon: <ServiceCovid19Vax />
  },
  [SERVICE_COVID_19_VACCINE_JNJ]: {
    label: "Covid-19 Vaccination - Johnson & Johnson",
    icon: <ServiceCovid19Vax />
  },
  [SERVICE_COVID_19_VACCINE_NOVAVAX_1]: {
    label: "Covid-19 Vaccination - Dose 1 (Novavax)",
    icon: <ServiceCovid19Vax />
  },
  [SERVICE_COVID_19_VACCINE_NOVAVAX_2]: {
    label: "Covid-19 Vaccination - Dose 2 (Novavax)",
    icon: <ServiceCovid19Vax />
  },
  [SERVICE_COVID_19_VACCINE_AZ_1]: {
    label: "Covid-19 Vaccination - Dose 1 (AstraZeneca)",
    icon: <ServiceCovid19Vax />
  },
  [SERVICE_COVID_19_VACCINE_AZ_2]: {
    label: "Covid-19 Vaccination - Dose 2 (AstraZeneca)",
    icon: <ServiceCovid19Vax />
  }
};

export { API_SERVICE_MAP };
